module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "bar-container",
    staticClass: "slider-bar-container weex-ct weex-div",
    style: (_vm._px2rem(_vm.containerStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "range-bar weex-ct weex-div",
    style: (_vm._px2rem(_vm.rangeBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "value-bar",
    staticClass: "value-bar weex-ct weex-div",
    style: (_vm._px2rem(_vm.valueBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide-block-1",
    staticClass: "slide-block weex-ct weex-div",
    style: (_vm._px2rem(_vm.blockStyle1, 75)),
    attrs: {
      "prevent-move-event": _vm.preventMoveEvent,
      "weex-type": "div",
      "data-evt-panstart": "",
      "data-evt-panmove": "",
      "data-evt-touchstart": "",
      "data-evt-touchend": "",
      "data-evt-horizontalpan": ""
    },
    on: {
      "panstart": function($event) {
        $event.stopPropagation();
        return _vm.webStartHandler($event)
      },
      "panmove": function($event) {
        $event.stopPropagation();
        return _vm.webMoveHandler1($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.weexStartHandler1($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.weexEndHandler($event)
      },
      "horizontalpan": _vm.weexHandler1
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  })]), _vm._v(" "), (_vm.range) ? _c('div', {
    ref: "slide-block-2",
    staticClass: "slide-block weex-ct weex-div",
    style: (_vm._px2rem(_vm.blockStyle2, 75)),
    attrs: {
      "prevent-move-event": _vm.preventMoveEvent,
      "weex-type": "div",
      "data-evt-panstart": "",
      "data-evt-panmove": "",
      "data-evt-touchstart": "",
      "data-evt-touchend": "",
      "data-evt-horizontalpan": ""
    },
    on: {
      "panstart": function($event) {
        $event.stopPropagation();
        return _vm.webStartHandler($event)
      },
      "panmove": function($event) {
        $event.stopPropagation();
        return _vm.webMoveHandler2($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.weexStartHandler2($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.weexEndHandler($event)
      },
      "horizontalpan": _vm.weexHandler2
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-100ca2e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-100ca2e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-slider-bar/index.vue
// module id = 573
// module chunks = 0 1